import { IListItem } from "../../../interface/list-item";
import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { getCountries } from "../service/countries.api";

const {
    actions: countriesActions,
    reducer: countriesReducer,
    epic: countriesEpic,
} = createIGSERedux<Array<IListItem>>({
    actionNames: {
        init: "COUNTRIES_INIT",
        get: "COUNTRIES_GET",
        success: "COUNTRIES_SUCCESS",
        error: "COUNTRIES_ERROR",
    },
    fetcher: () => getCountries(selectAuthTokens()),
    selector: (state: IRootState) => state.countries,
});

export { countriesActions, countriesReducer, countriesEpic };
